// extracted by mini-css-extract-plugin
module.exports = {"link":"skip-to-main-content_link__A8GMw"};